/**
 * Uhrzeit als zwei Auswahlräder: Stunde und Minute.
 *
 * Ersetzt <input type="time"> bewusst. iOS beachtet dort das `step`-Attribut
 * nicht und bietet trotzdem jede einzelne Minute an — genau das soll hier
 * nicht sein. Mit zwei <select> gibt es die krummen Minuten gar nicht erst,
 * und auf dem Handy erscheinen zwei kurze Räder statt eines langen.
 *
 * Das Raster kommt aus den Einstellungen (Vorgabe: Viertelstunden).
 */
export default function Uhrzeitwahl({ wert, raster = 15, beiAenderung, kennung, pflicht = false }) {
  const [stundeText, minuteText] = (wert || '').split(':')
  const stunde = stundeText === undefined || stundeText === '' ? '' : Number(stundeText)
  const minute = minuteText === undefined || minuteText === '' ? '' : Number(minuteText)

  const stunden = Array.from({ length: 25 }, (_, i) => i) // 0 … 24 (24:00 = Tagesende)

  const minuten = []
  for (let m = 0; m < 60; m += raster) minuten.push(m)
  // Ein bereits erfasster Wert, der nicht ins Raster passt (etwa :34 aus einer
  // früheren Einstellung), bleibt wählbar — sonst würde er beim Bearbeiten
  // stillschweigend verschoben.
  if (minute !== '' && !minuten.includes(minute)) minuten.push(minute)
  minuten.sort((a, b) => a - b)

  /**
   * Meldet auch halb ausgefüllte Werte: „14:“ heißt Stunde gewählt, Minute
   * offen. Sonst würde die vorbelegte Stunde beim ersten Antippen des
   * Minutenrads verschwinden — und das Formular könnte keine Vorbelegung
   * anbieten, bei der die Minute bewusst leer bleibt.
   */
  function melde(neueStunde, neueMinute) {
    // Um 24 Uhr gibt es nur die volle Stunde — alles andere wäre der nächste Tag.
    const rohMinute = neueStunde === 24 ? 0 : neueMinute
    const s = neueStunde === '' ? '' : String(neueStunde).padStart(2, '0')
    const m = rohMinute === '' ? '' : String(rohMinute).padStart(2, '0')
    beiAenderung(s === '' && m === '' ? '' : `${s}:${m}`)
  }

  return (
    <div className="uhrzeit">
      <select
        id={kennung}
        className="uhrzeit__teil"
        required={pflicht}
        value={stunde}
        onChange={(e) => melde(Number(e.target.value), minute)}
        aria-label="Stunde"
      >
        <option value="" disabled>
          --
        </option>
        {stunden.map((s) => (
          <option key={s} value={s}>
            {String(s).padStart(2, '0')}
          </option>
        ))}
      </select>

      <span className="uhrzeit__trenner">:</span>

      <select
        className="uhrzeit__teil"
        required={pflicht}
        value={stunde === 24 ? 0 : minute}
        disabled={stunde === 24}
        onChange={(e) => melde(stunde, Number(e.target.value))}
        aria-label="Minute"
      >
        <option value="" disabled>
          --
        </option>
        {minuten.map((m) => (
          <option key={m} value={m}>
            {String(m).padStart(2, '0')}
          </option>
        ))}
      </select>
    </div>
  )
}
